import { render } from 'preact';
import { App } from './ui/app.js';
import { engine } from './engine/engine.js';
import { registerServiceWorker } from './sw-register.js';
import { ui } from './ui/ui.js';
import './ui/tokens.css';
import './ui/app.css';

// The engine is reachable from the page for the Playwright tests (e2e/); the screen uses the module import.
(window as unknown as { __salsacount: { engine: typeof engine } }).__salsacount = { engine };

render(<App />, document.getElementById('app')!);

registerServiceWorker(() => ui.patch({ update: true }));
